module.exports = __webpack_public_path__ + "img/p4_fenjingdiemeng.a5607e25.jpg";